<form [formGroup]="generalForm">
  <div class="row">
    <div class="col-6">
      <div class="form-section">
        <div class="mb-3">
          <label for="reference" class="form-label">{{
            "inputs.reference" | translate
            }}</label>
          <div class="input-group div-copy">
            <input type="text" class="form-control" id="campaign_reference" #inputCampaignsReference
              formControlName="campaign_reference" placeholder="{{
                  'inputs.reference' | translate
                }}" required />
            <div class="input-group-append">
              <button class="btn btn-outline-secondary copy" type="button"
                (click)="copyToClipboard(inputCampaignsReference.value,$event)">
                <i class="icon-copy"></i>
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="col-6">
      <div class="form-section">
        <div class="mb-3">
          <label for="name" class="form-label">{{
            "inputs.name" | translate
            }}</label>
          <div class="input-group div-copy">
            <input type="text" class="form-control" id="name" #inputName formControlName="name" placeholder="{{
                  'inputs.name' | translate
                }}" required />
            <div class="input-group-append">
              <button class="btn btn-outline-secondary copy" type="button"
                (click)="copyToClipboard(inputName.value,$event)">
                <i class="icon-copy"></i>
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>
    <div class="row">
       <div class="col-4">
        <div class="mb-3">
          <label for="vehicle_discount_code" class="form-label">{{
            "inputs.campaign_stock_reference" | translate
          }}</label>
          <input
            type="text"
            [disabled]="true"
            class="form-control"
            id="campaign_stock_reference"
            required
            formControlName="campaign_stock_reference"
            placeholder="{{ 'inputs.campaign_stock_reference' | translate }}"
          />
        </div>
      </div>
      <div class="col-4">
        <div class="mb-3">
          <label for="warning_label" class="form-label">{{
            "inputs.warning_label" | translate
          }}</label>
          <div class="input-group">
            <select id="warning_label" class="form-control" formControlName="warning_label">
              <option value="" disabled selected>{{ "inputs.select_option" | translate }}</option>
              <option value="low_stock">{{ "inputs.warning_label_options.low_stock" | translate }}</option>
              <option value="quote_review">{{ "inputs.warning_label_options.quote_review" | translate }}</option>
              <option value="stock_review">{{ "inputs.warning_label_options.stock_review" | translate }}</option>
              <option value="other">{{ "inputs.warning_label_options.other" | translate }}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  <!-- Vendor,sup,bro,dealer -->
  <div class="form-section">
    <div class="row">
      <div class='col-4'>
        <div class="mb-3">
          <label for="vendor" class="form-label">{{ "inputs.vendor" | translate }}
            <!--   <span class="required">*</span> -->
          </label>
          <ng-select formControlName="vendor_id" [items]="vendorData" bindValue="reference" bindLabel="name"
            [placeholder]="'inputs.select_option' | translate" [searchable]="true" [clearable]="false">
          </ng-select>
        </div>
      </div>

      <div class='col-4'>
        <div class="mb-3">
          <label for="vendor" class="form-label">{{ "inputs.campaign_vendor_reference" | translate }}
            <!--   <span class="required">*</span> -->
          </label>
          <!-- <select id="vendor" class="form-control" formControlName="campaign_vendor_reference">
              <option value="" disabled selected>
                {{ "inputs.select_option" | translate }}
              </option>
              <option *ngFor="let vendor of vendorData" [value]="vendor.reference">
                {{ vendor.campaign_vendor_reference }}
              </option>
            </select> -->
          <div class="input-group div-copy">
            <input type="text" class="form-control" id="campaign_vendor_reference" #inputCampaignsReference
              formControlName="campaign_vendor_reference" placeholder="{{
                                        'inputs.campaign_vendor_reference' | translate
                                      }}" required />
            <div class="input-group-append">
              <button class="btn btn-outline-secondary copy" type="button"
                (click)="copyToClipboard(inputCampaignsReference.value,$event)">
                <i class="icon-copy"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="col-4">
        <div class="mb-3">
          <label for="broker" class="form-label">{{ "inputs.broker" | translate }}
            <!--   <span class="required">*</span> -->
            <!-- <span *ngIf="hasExcludedBrokers" class="badge bg-warning ms-1"
                  matTooltip="{{ 'tooltip.broker_exclude_warning' | translate }}">
                  ⚠️
                </span> --></label>
          <ng-select formControlName="broker_id" [items]="brokerData" bindValue="reference" bindLabel="name"
            [placeholder]="'inputs.select_option' | translate" [searchable]="true" [clearable]="true">
          </ng-select>
        </div>
      </div>
      <!--  <div class="col-4">
        <div class="form-section">
          <div class="mb-3">
            <label for="units" class="form-label">{{
              "inputs.total_units" | translate
              }}</label>
            <div class="input-group div-copy">
              <input type="text" class="form-control" id="units" formControlName="units" placeholder="{{
                  'inputs.total_units' | translate
                }}" required />
            </div>

          </div>
        </div>
      </div> -->
    </div>
  </div>

  <div class="form-section">
    <div class="row">
      <div class="col-4">
        <div class="mb-3">
          <label for="start_date" class="form-label">{{ "inputs.start_date"
            | translate }}
          </label>
          <mat-form-field appearance="fill">
            <input matInput [matDatepicker]="start_date" formControlName="start_date" placeholder="{{
                'inputs.start_date' | translate
              }}" />
            <mat-datepicker-toggle matSuffix [for]="start_date"></mat-datepicker-toggle>
            <mat-datepicker #start_date></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
      <div class="col-4">
        <div class="mb-3">
          <label for="end_date" class="form-label">{{ "inputs.end_date"
            | translate }}
          </label>
          <mat-form-field appearance="fill">
            <input matInput [matDatepicker]="end_date" formControlName="end_date" placeholder="{{
                'inputs.end_date' | translate
              }}" />
            <mat-datepicker-toggle matSuffix [for]="end_date"></mat-datepicker-toggle>
            <mat-datepicker #end_date></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
      <div class="col-4" *ngIf="account_type == 'supplier'">
        <div class="mb-3">
          <label for="vendor_end_date" class="form-label">{{ "inputs.vendor_end_date"
            | translate }}
          </label>
          <mat-form-field appearance="fill">
            <input matInput [matDatepicker]="vendor_end_date" formControlName="vendor_end_date" placeholder="{{
                'inputs.vendor_end_date' | translate
              }}" />
            <mat-datepicker-toggle matSuffix [for]="vendor_end_date"></mat-datepicker-toggle>
            <mat-datepicker #vendor_end_date></mat-datepicker>
          </mat-form-field>
        </div>
      </div>

    </div>
  </div>
  <div class="row" *ngIf="campaignData?.stage">
    <div class="col-6">
      <div class="mb-3">
        <ng-select formControlName="stage" [items]="stagesList" bindValue="key"
          [placeholder]="'inputs.select_option' | translate" [searchable]="true" [clearable]="false"
          (change)="changeStage($event?.key)">
          <ng-template ng-label-tmp let-item="item">{{ "badge-status_select-stage." + item.key | translate }}</ng-template>
          <ng-template ng-option-tmp let-item="item">{{ "badge-status_select-stage." + item.key | translate }}</ng-template>
        </ng-select>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="mb-3">
      <label for="comments" class="form-label">{{
        "inputs.comments" | translate
        }}</label>
      <textarea class="form-control textarea150" id="comments" rows="5" formControlName="comments"></textarea>
    </div>
  </div>

  <div class="row">
    <div class="mb-3">
      <label for="delivery_comments" class="form-label">{{
        "inputs.delivery_comments" | translate
        }}</label>
      <textarea class="form-control textarea150" id="delivery_comments" rows="5"
        formControlName="delivery_comments"></textarea>
    </div>
  </div>

    <div class="row" *ngIf="account_type =='supplier'" [ngClass]="{ 'private-background': 'internal' }">
    <div class="mb-3">
      <label for="private_comments" class="form-label">{{
        "inputs.private_comments" | translate
        }}</label>
      <textarea class="form-control textarea150" id="private_comments" rows="5"
        formControlName="private_comments"></textarea>
    </div>
  </div>

  <!--  <div *ngIf="draft">
    <div class="form-section">
      <label for="stage" class="form-label">{{ "inputs.stage" | translate }}
        <span class="required">*</span></label>
      <div class="row">
        <div class="col-6">
          <div class="mb-3">

            <select id="stage" class="form-control" formControlName="stage" (ngModelChange)="changeStage($event)">
              <option [value]="orderData.stage" selected>
                {{
                "badge-status_select-stage." + orderData.stage
                | translate
                }}
              </option>
              <option *ngFor="let type of orderData.stages" [value]="type" [selected]="type === orderData.stage">
                {{
                "badge-status_select-stage." + type | translate
                }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-6">
          <div class="btn-next" *ngIf="btn_fast_actions">
            <button *ngIf="next_ok" type="submit" class="btn btn-primary btn-next_ok"
              (click)="onSubmitOrderFast(next_ok)"> <i class="icon-next-circle"></i>
              {{ "badge-status_select-stage."+ next_ok | translate }}
            </button>

            <button *ngIf="next_ko" type="submit" class="btn btn-primary btn-next_ko"
              (click)="onSubmitOrderFast(next_ko)"> <i class="icon-pause-circle"></i>
              {{ "badge-status_select-stage."+ next_ko | translate }}
            </button>
          </div>
        </div>
      </div>
      <div class="row private-background" *ngIf="role == 'Logistics'|| role == 'Workshop'">
        <div class="mb-3">
          <label for="notes" class="form-label">{{
            "inputs.addinternote" | translate
            }}</label>
          <textarea class="form-control textarea150" id="notes" rows="5" formControlName="notes"></textarea>
        </div>
      </div>
      <div class="row" *ngIf="role != 'Logistics' &&  role != 'Workshop'">
        <div class="mb-3">
          <label for="notes" class="form-label">{{
            "inputs.addnote" | translate
            }}</label>
          <textarea class="form-control textarea150" id="notes" rows="5" formControlName="notes"></textarea>
        </div>
      </div>
    </div>
  </div> -->
</form>